import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';
import {AuthService, SidebarService} from '../../../core/services';
import {Router} from '@angular/router';
import {DialogService} from '../../../core/services/dialog.service';
import {MatDialog} from '@angular/material';
import {ContactDialogComponent} from '../dialogs';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnDestroy  {
  SAHBAK_URL = `${environment.SITE_URL}/`;
  mobileQuery: MediaQueryList;
  pages = [
    {name: 'ראשי', icon: 'home', class: 'ic-custom', route: '/', type: 'route'},
    {name: 'פרופיל', icon: 'profile', class: 'ic-custom', route: '/profile', type: 'route'},
    {name: 'הודעות', icon: 'chat-bubble', class: 'ic-custom-rev', route: '/inbox', type: 'route'},
    {name: 'חבילות ועלויות', icon: 'plans', class: 'ic-custom', route: '/plans', type: 'route'},
    // {name: 'התראות', icon: 'notifications', class: 'ic-custom-rev', route: '/notifications'},
    // {name: 'תקנון', icon: 'terms', class: 'ic-custom-rev', route: '/terms', type: 'route'},
    {name: 'חזרה לאתר סחבק', class: 'ic-custom-rev', icon: 'jobs', route: '/home', type: 'url'},
    {name: 'צריכים עזרה?', class: 'ic-custom', icon: 'info-blob', route: '/', type: 'dialog'},
    // {name: 'התנתקות', icon: 'logout', class: 'ic-custom', route: '/logout', type: 'route'},
  ];
  sideBarState$: boolean;
  readonly mobileQueryListener: () => void;
currentPage:""
  constructor(
    private router: Router,
    private dialogService: DialogService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    public dialog: MatDialog,
    private sidebarService: SidebarService,
    private authService: AuthService) {

    this.mobileQuery = media.matchMedia('(max-width: 1280px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    // this.mobileQuery.addEventListener('change', this.mobileQueryListener);

    this.sidebarService.onSidebarState().subscribe( state => {this.sideBarState$ = state; });
  }

  ngOnDestroy() {
    // this.mobileQuery.removeEventListener('change', this.mobileQueryListener);
  }

  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  logout() {
    this.dialogService.open({
      title: 'בטוחים שאתם עוזבים?',
      message: 'בלחיצה על אישור יבוצע ניתוק מהמערכת',
      cancelText: 'ביטול',
      confirmText: 'אישור'
    });

    this.dialogService.confirmed().subscribe( data => {
      if (data) {
        this.authService.logout();
        this.router.navigateByUrl('/auth/login');
      }
    });
  }

  openHelpDialog() {
    this.dialog.open(ContactDialogComponent, {
      panelClass: 'contact-dialog',
      data: {
        context: 'sidebar'
      }
    });
  }

  cllEvent() {
    window.dataLayer.push({
      event: 'employer-call',
      eventCategory: 'sidebar',
      eventAction: 'success',
    });
  }
}
